import styled from "styled-components";

export const Wrapper = styled.div`
	display: flex;
	width: 100%;
	flex-direction: row;
	align-items: center;
	justify-content: flex-end;
`;
